if ( module.hot ) {
  module.hot.accept();
}

/**
 * Platform page behaviours (G25-1085).
 *
 * Smooth scroll, the IntersectionObserver lazy-loader and its fallback, the
 * YouTube embed plugin and the sticky call/appointment buttons all used to be
 * inlined by views/includes/global/js/externalScripts.cfm on every page of every
 * site — roughly 6.5 KB of identical, uncached, unminified script per document.
 *
 * Only the sticky buttons are per-site. Their two flags now arrive in a JSON
 * island (#gpw-sticky-buttons-config) that the view emits only when the same
 * conditions as before are met, so the ADA-cookie and theme-selector exclusions
 * still live with the rest of that condition in the view rather than being
 * re-derived here. No island means the feature is off and nothing binds.
 *
 * Note on `#` characters: in externalScripts.cfm these selectors sat inside
 * <cfoutput>, so they were written '##nav-wrap' and [href^="##"]. Here they are
 * plain JavaScript and use a single '#'.
 */

/* ------------------------------------------------------------------ *
 * Smooth scroll (added Dec 2020)
 * ------------------------------------------------------------------ */
$(window).load(function() {
	$('a[href^="#"]')
		.not('[href="#"]')
		.not('[href="#0"]')
		.not('.accordion-toggle')
		.click(function(event) {
			event.preventDefault();
			document.querySelector(this.getAttribute('href')).scrollIntoView(this);
		});
});

/* ------------------------------------------------------------------ *
 * Lazy loading
 * ------------------------------------------------------------------ */
document.addEventListener("DOMContentLoaded", function() {
	var lazyElements;

	if ("IntersectionObserver" in window) {
		lazyElements = document.querySelectorAll(".lazy");
		var observer = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					if (entry.target.nodeName === 'VIDEO') {
						for (var source in entry.target.children) {
							var videoSource = entry.target.children[source];

							if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
								videoSource.src = videoSource.dataset.src;
							}
						}

						entry.target.load();
					} else if (entry.target.nodeName === 'IMG') {
						var image = entry.target;
						image.src = image.dataset.src;
					}

					entry.target.classList.remove("lazy");
					observer.unobserve(entry.target);
				}
			});
		}, {
			rootMargin: "0px 0px 300px 0px"
		});

		lazyElements.forEach(function(ele) {
			observer.observe(ele);
		});
	} else {
		var lazyloadThrottleTimeout;
		// Was an implicit global inline. Declared here so the module does not
		// depend on sloppy mode once it is bundled.
		var lazyloadImages = document.querySelectorAll(".lazy");

		var lazyload = function () {
			if (lazyloadThrottleTimeout) {
				clearTimeout(lazyloadThrottleTimeout);
			}

			lazyloadThrottleTimeout = setTimeout(function() {
				var scrollTop = window.pageYOffset;
				lazyloadImages.forEach(function(img) {
					if(img.offsetTop < (window.innerHeight + scrollTop)) {
						img.src = img.dataset.src;
						img.classList.remove('lazy');
					}
				});
				if (lazyloadImages.length == 0) {
					document.removeEventListener("scroll", lazyload);
					window.removeEventListener("resize", lazyload);
					window.removeEventListener("orientationChange", lazyload);
				}
			}, 20);
		};

		document.addEventListener("scroll", lazyload);
		window.addEventListener("resize", lazyload);
		window.addEventListener("orientationChange", lazyload);
	}
});

/* ------------------------------------------------------------------ *
 * YouTube embed plugin
 * ------------------------------------------------------------------ */
(function ($) {
	"use strict";

	$.fn.embedyt = function (youid, width, height) {
		var htm = '<img class="img-responsive youtube-img" width="100%" height="auto" src="//img.youtube.com/vi/' + youid + '/0.jpg" /><input style="cursor:pointer;" class="play-youtube" type="button" value=" play " />';
		this.html(htm);

		if (width !== 0 || height !== 0) {
			var ifhtml = '<div class="video-container">\
						<iframe width="' + width + '" height="' + height + '" \
						src="//www.youtube.com/embed/' + youid + '?autoplay=1' + '&rel=0" frameborder="0"\
						allowfullscreen></iframe></div>';
		} else {
			var ifhtml = '<div class="video-container" style="width: 100%; height: auto;">\
						<iframe width="100%" height="auto" \
						src="//www.youtube.com/embed/' + youid + '?autoplay=1' + '&rel=0" frameborder="0"\
						allowfullscreen></iframe></div>'
		}

		this.find(".play-youtube").bind('click', function ($) {
			jQuery(this).css("cursor", "progress");
			jQuery(this).parent().replaceWith(ifhtml);
		});
	};

	$.fn.getYouTubeID = function (youEmbed) {
		/*
		Types of URLS supported by regex parser...
		//www.youtube.com/watch?v=0zM3nApSvMg&feature=feedrec_grec_index
		//www.youtube.com/user/IngridMichaelsonVEVO#p/a/u/1/QdK8U-VIH_o
		//www.youtube.com/v/0zM3nApSvMg?fs=1&amp;hl=en_US&amp;rel=0
		//www.youtube.com/watch?v=0zM3nApSvMg#t=0m10s
		//www.youtube.com/embed/0zM3nApSvMg?rel=0
		//www.youtube.com/watch?v=0zM3nApSvMg
		//youtu.be/0zM3nApSvMg
		*/
		var regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
		var match = youEmbed.match(regExp);

		if (match && match[1].length >= 10){
			return match[1];
		} else {
			console.log('Failed Parse');
		}
	};

}(window.jQuery||window.$));

jQuery(function () {
	jQuery("div.youtubeembed, div.youtubeembed-v2").each(function (index) {
		var youID = jQuery(this).getYouTubeID(jQuery(this).data('embed'));
		var width = 0;
		var height = 0;

		if (jQuery(this).data('width')) {
			width = jQuery(this).data('width');
		}
		if (jQuery(this).data('height')) {
			height = jQuery(this).data('height');
		}
		jQuery(this).embedyt(youID, width, height);
	});
});

/* ------------------------------------------------------------------ *
 * Sticky appointment / call buttons
 *
 * Site settings: sticky_appt_btn, sticky_call_btn. Testing checklist lives
 * with the config island in externalScripts.cfm.
 * ------------------------------------------------------------------ */
$(window).load(function() {
	var configEl = document.getElementById('gpw-sticky-buttons-config');
	if (!configEl) return;

	var config;
	try {
		config = JSON.parse(configEl.textContent);
	} catch (e) {
		return;
	}

	var stickyAppt = !!config.appt;
	var stickyCall = !!config.call;
	if (!stickyAppt && !stickyCall) return;

	var $apptBtn = $('.make-an-appt').filter(':visible').first();
	var $callBtn = $('.phone-number').not('.mobile-btn').filter(':visible').first();
	var $navWrap = $('#nav-wrap');
	var apptOrigPos = $apptBtn.css('position');
	var callOrigPos = $callBtn.css('position');

	/**
	 * The right edge to pin against.
	 *
	 * This used to be $('.container').first(), which breaks whenever the first
	 * .container in the DOM is hidden — commonly a leftover top-banner block in
	 * customBodyHTML that a redesign hid with CSS instead of deleting, since
	 * customBodyHTML renders before .site-wrap. jQuery is asymmetric on hidden
	 * elements: offset() returns 0 but outerWidth() still reports the computed
	 * width, so containerRight came out roughly double and the button pinned
	 * mid-screen. Prefer the container the button actually lives in, then any
	 * visible one, and only then fall back to the old behaviour.
	 */
	function resolveContainer() {
		var $c = $callBtn.closest('.container');
		if (!$c.length) { $c = $apptBtn.closest('.container'); }
		if (!$c.length) { $c = $('.container').filter(':visible').first(); }
		if (!$c.length) { $c = $('.container').first(); }
		return $c;
	}

	var triggerTop = 0;
	if (stickyAppt && stickyCall) {
		triggerTop = Math.min($apptBtn.offset().top, $callBtn.offset().top);
	} else if (stickyAppt) {
		triggerTop = $apptBtn.offset().top;
	} else if (stickyCall) {
		triggerTop = $callBtn.offset().top;
	}

	$(window).on('scroll', function() {
		if ($(window).scrollTop() >= triggerTop) {
			var navOffset = $navWrap.hasClass('nav-fixed') ? $navWrap.outerHeight() : 0;
			var $container = resolveContainer();
			var containerRight = $(window).width() - ($container.offset().left + $container.outerWidth());

			var baseTop = navOffset + 15;
			var apptHeight = $apptBtn.outerHeight();
			var callHeight = $callBtn.outerHeight();
			var maxHeight = Math.max(apptHeight, callHeight);

			// Themes often anchor these buttons with bottom/left (e.g. bottom:38px
			// in the header). Left in place alongside our top/right, a fixed element
			// with height:auto stretches between them into an invisible full-height
			// overlay that swallows clicks on whatever sits beneath it (SUP-1239).
			if (stickyCall) {
				var callTop = baseTop + (maxHeight - callHeight) / 2;
				$callBtn.css({ position: 'fixed', top: callTop + 'px', right: containerRight + 'px', bottom: 'auto', left: 'auto', zIndex: 197, height: 'auto', margin: 0 });
			}
			if (stickyAppt) {
				var apptTop = baseTop + (maxHeight - apptHeight) / 2;
				var apptRight = stickyCall ? (containerRight + $callBtn.outerWidth(true) + 10) : containerRight;
				$apptBtn.css({ position: 'fixed', top: apptTop + 'px', right: apptRight + 'px', bottom: 'auto', left: 'auto', zIndex: 197, height: 'auto', margin: 0 });
			}
		} else {
			if (stickyCall) { $callBtn.css({ position: callOrigPos, top: '', right: '', bottom: '', left: '', zIndex: '', height: '', margin: '' }); }
			if (stickyAppt) { $apptBtn.css({ position: apptOrigPos, top: '', right: '', bottom: '', left: '', zIndex: '', height: '', margin: '' }); }
		}
	});
});



// WEBPACK FOOTER //
// ./gpw-site-behaviors.js